(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.pdf
  
  (:require
   [clojure.string :as s]
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.epc-table :as epc-table]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]
   [potpuri.core :as potpuri]
   [reagent.dom.server :as rs]))

(defn custom-optional-footer
  ([data]
   (custom-optional-footer data {}))
  ([data {:keys [margin-top] :as _props}]
   (text-content/optional-footer data {:resi-v2-custom-style? true
                                       :margin-top    (or margin-top 15)
                                       :margin-bottom 0
                                       :margin-left   0
                                       :paragraph-margin-bottom 0})))

(defn custom-rich-content
  [data]
  (text-content/rich-content data {:resi-v2-custom-style? true}))

(defn image
  [{:keys [data width height]}]
  (when-not (cu/blank-value? (:image data))
    (card/custom-margins-card
     ""
     [0 0 0 20]
     (cond-> {:image (str (:image data))}
       width  (assoc :width width)
       height (assoc :height height))
     (custom-optional-footer data {:margin-top 5}))))

(defn empty-chart-data?
  [chart-data]
  (->> chart-data
       :figures
       :series
       (filter (fn [{:keys [data]}]
                 (seq (remove nil? data))))
       (count)
       (= 0)))

(defn strategy-text
  [data]
  [(card/custom-margins-card
    "Strategy"
    [0 0 0 40]
    (custom-rich-content
     (get-in data [:strategy :rich-content])))])

(defn portfolio-update-text
  [data]
  [(card/custom-margins-card
    "Portfolio Update"
    [0 20 0 30]
    (custom-rich-content
     (get-in data [:portfolio-update-text :rich-content])))])

(defn investment-activity-and-pipeline-text
  [data]
  [(card/custom-margins-card
    "Investment Activity and Pipeline"
    [0 0 0 60]
    (custom-rich-content
     (get-in data
             [:investment-activity-and-pipeline-text :rich-content])))])

(defn performance-and-outlook-text
  [data]
  [(card/custom-margins-card
    "Forward Funding Investments and Major Capex Projects"
    [0 0 0 30]
    (custom-rich-content
     (get-in data [:performance-and-outlook-text :rich-content])))])

(defn esg-summary-text
  [data]
  [(card/custom-margins-card
    "Sustainability Summary"
    [0 20 0 40]
    (custom-rich-content
     (get-in data [:esg-summary-text :rich-content])))])

(defn gresb-text
  [data]
  [(card/custom-margins-card
    "GRESB"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:gresb-text :rich-content])))])

(defn epc-text
  [data]
  [(card/custom-margins-card
    "Energy Performance Certificates"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:epc-text :rich-content])))])

(defn eu-taxonomy-text
  [data]
  [(card/custom-margins-card
    "EU Taxonomy Alignment"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:eu-taxonomy-text :rich-content])))])

(defn green-certificates-text
  [data]
  [(card/custom-margins-card
    "Green Building Certifications"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:green-certificates-text :rich-content])))])

(defn green-electricity-text
  [data]
  [(card/custom-margins-card
    "Renewable Energy"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:green-electricity-text :rich-content])))])

(defn esg-investments-text
  [data]
  [(card/custom-margins-card
    "Sustainability Investments"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:esg-investments-text :rich-content])))])

(defn crrem-pathway-text
  [data]
  [(card/custom-margins-card
    "2035 Net Zero Target"
    [0 0 0 0]
    (custom-rich-content
     (get-in data [:crrem-pathway-text :rich-content])))])

(defn tenant-satisfaction-text
  [data]
  [(card/custom-margins-card
    "Tenant Satisfaction"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:tenant-satisfaction-text :rich-content])))])

(defn fees-disclosure-text
  [data]
  [(card/custom-margins-card
    "Disclosure About Service Fees Charged by CapMan"
    [0 20 0 20]
    (custom-rich-content
     (get-in data [:fees-disclosure-text :rich-content])))])

(defn disclaimer-text
  [data]
  [(card/custom-margins-card
    ""
    [0 20 0 20]
    (custom-rich-content
     (get-in data [:disclaimer-text :rich-content])))])


;; ---------- Tables ----------

(defn fund-summary-table
  [data]
  [(card/custom-margins-card-with-background
    "Fund Summary"
    [0 20 0 40]
    (vertical-table-pdf/table
     (:fund-summary data)
     {:font-size 9
      :even-row-background-color "#F0EEEA"
      :table-widths [260 240]})
    (custom-optional-footer (:fund-summary data)))])

(defn pivot-contacts-data
  [{:keys [rows]}]
  (let [fields   [:title :name :title-2 :email :phone]
        row-data (mapv :row-data rows)
        columns  (apply mapv vector row-data)]
    (into {}
          (map-indexed
           (fn [idx contact-values]
             [(keyword (str "contact-" (inc idx)))
              (zipmap fields contact-values)]))
          columns)))

(defn contact-block
  [image-data {:keys [title name title-2 email phone]}]
  [(image {:data   image-data
           :width  100
           :height 100})
   {:text title  :margin [0 0 0 0] :fontSize 9 :bold true}
   {:text name   :margin [0 2 0 0] :fontSize 9}
   (when-not (cu/blank-value? title-2)
     {:text title-2  :margin [0 2 0 0] :fontSize 9})
   (when-not (cu/blank-value? email)
     {:text email  :margin [0 2 0 0] :fontSize 9})
   (when-not (cu/blank-value? phone)
     {:text phone  :margin [0 2 0 0] :fontSize 9})])

(defn contact-information-1
  [data]
  (let [contact-images (:contact-images data)
        pivoted-data   (pivot-contacts-data
                        {:rows (-> data :contact-information
                                   :figures :rows)})]
    [(card/custom-margins-card
      "Contact Information"
      [0 20 0 20]
      [{:columns
        [{:width     (/ page/page-width-portrait 2)
          :stack     [(contact-block (:contact-1 contact-images)
                                     (:contact-1 pivoted-data))]
          :alignment :center
          :margin    [0 0 30 0]}
         {:width     (/ page/page-width-portrait 2)
          :stack     [(contact-block (:contact-2 contact-images)
                                     (:contact-2 pivoted-data))]
          :alignment :center
          :margin    [0 0 40 0]}]
        :margin [0 20 0 0]
        :unbreakable true}])]))

(defn contact-information-2
  [data]
  (let [contact-images (:contact-images data)
        pivoted-data   (pivot-contacts-data
                        {:rows (-> data :contact-information
                                   :figures :rows)})]
    [(card/custom-margins-card
      "Contact Information (continued)"
      [0 20 0 60]
      [{:columns
        [{:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-3 contact-images)
                                     (:contact-3 pivoted-data))]
          :alignment :center
          :margin    [0 0 30 0]}
         {:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-4 contact-images)
                                     (:contact-4 pivoted-data))]
          :alignment :center
          :margin    [0 0 40 0]}
         {:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-5 contact-images)
                                     (:contact-5 pivoted-data))]
          :alignment :center
          :margin    [0 0 40 0]}]
        :margin [0 20 0 0]}])]))

(defn valuation-details-table
  [data]
  [(card/custom-margins-card-with-background
    "Legal, Administration and Property Valuation Details"
    [0 0 0 20]
    (vertical-table-pdf/table
     (:valuation-details data)
     {:font-size 9
      :even-row-background-color "#F0EEEA"
      :table-widths [260 240]})
    (custom-optional-footer (:valuation-details data)))])

(defn fund-capital-metrics-table
  [data]
  [(card/custom-margins-card
    "Key Metrics"
    [0 20 0 30]
    (vertical-table-pdf/table (:fund-capital-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:fund-capital-metrics data)))])

(defn fund-kpis-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:fund-kpis-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:fund-kpis-metrics data)))])

(defn performance-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:performance-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:performance-metrics data)))])

(defn portfolio-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:portfolio-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:portfolio-metrics data)))])

(defn fa-icon
  [{:keys [unicode color size]
    :or   {color "#333333" size 11}}]
  {:text     unicode
   :font     "FontAwesome"
   :color    color
   :bold     true
   :fontSize size
   :margin [0 3 0 0]})

(defn trend-indicator-row-fa
  ([]
   (trend-indicator-row-fa {}))
  ([{:keys [text size gap borders? icons]
     :or   {text     "Trend indicator (outlook)"
            size     9
            gap      8
            borders? false
            icons    {:up "\uf062" :down "\uf063" :right "\uf061"}}}]
   (let [gap-node {:width gap :text ""}]
     {:margin [0 10 0 0]
      :table  {:widths ["*"]
               :body
               [[{:fillColor "#F0EEEA"
                  :border    (if borders? [true true true true]
                                         [false false false false])
                  :columns   [{:width  "auto"
                               :columns [(fa-icon {:unicode (:up icons)
                                                   :color   "#2ECC71"
                                                   :size    size})
                                         gap-node
                                         (fa-icon {:unicode (:down icons)
                                                   :color   "#E53935"
                                                   :size    size})
                                         gap-node
                                         (fa-icon {:unicode (:right icons)
                                                   :color   "#9E9E9E"
                                                   :size    size})]}
                              {:text      text
                               :margin    [10 4 0 0]
                               :fontSize  9
                               :color     "#333333"
                               :alignment "left"
                               :width     "*"}]}]]}
      :layout {:defaultBorder false}})))

(defn market-overview-table
  [data]
  [(card/custom-margins-card
    "Residential Market Snapshot"
    [0 20 0 30]
    (vertical-table-pdf/table (:market-overview data))
    (trend-indicator-row-fa {:size 9 :gap 10 :borders? false})
    (custom-optional-footer (:market-overview data)))])

(defn fund-returns-table
  [data]
  [(card/custom-margins-card
    "Fund Returns in %"
    [0 20 0 20]
    (vertical-table-pdf/table (:fund-returns-table data))
    (custom-optional-footer (:fund-returns-table data)))])

(defn benchmark-index-table
  [data]
  [(card/custom-margins-card
    "Benchmark Index: INREV European ODCE Index, Total Return in %"
    [0 0 0 20]
    (vertical-table-pdf/table (:benchmark-index data))
    (custom-optional-footer (:benchmark-index data)))])

(defn debt-kpis-table
  [data]
  [(card/custom-margins-card
    "Debt KPIs"
    [0 20 0 40]
    (vertical-table-pdf/table (:debt-kpis data))
    (custom-optional-footer (:debt-kpis data)))])

(defn debt-facilities-table
  [data]
  [(card/custom-margins-card
    "Debt Facilities"
    [0 0 0 40]
    (horizontal-table-pdf/table (:debt-facilities data))
    (custom-optional-footer (:debt-facilities data)))])

(defn portfolio-summary-table
  [data]
  [(card/custom-margins-card
    "Portfolio Summary"
    [0 20 0 60]
    (vertical-table-pdf/table (:portfolio-summary data))
    (custom-optional-footer (:portfolio-summary data)))])

(defn acquisitions-table
  [data]
  [(card/custom-margins-card
    "Acquisitions TTM"
    [0 20 0 60]
    (horizontal-table-pdf/table (:acquisitions data)
                                {:font-size 9})
    (custom-optional-footer (:acquisitions data)))])

(defn dispositions-table
  [data]
  [(card/custom-margins-card
    "Dispositions TTM"
    [0 0 0 60]
    (horizontal-table-pdf/table (:dispositions data)
                                {:font-size 9})
    (custom-optional-footer (:dispositions data)))])

(defn gresb-by-year-table
  [data]
  [(card/custom-margins-card
    "Fund GRESB Rating by Year"
    [0 0 0 20]
    (horizontal-table-pdf/table (:gresb-by-year data))
    (custom-optional-footer (:gresb-by-year data)))])

(defn portfolio-epc-table
  [data]
  (let [base   (horizontal-table-pdf/table (:portfolio-epc data))
        merged (epc-table/merge-epc-triangle-into-horizontal-table
                base {:size 7 :cell 10})]
    [(card/custom-margins-card
      "Portfolio EPC"
      [0 0 0 20]
      merged
      (custom-optional-footer (:portfolio-epc data)))]))

(defn green-certs-by-country-table
  [data]
  [(card/custom-margins-card
    "Certifications by Country"
    [0 0 0 20]
    (horizontal-table-pdf/table (:green-certs-by-country data))
    (custom-optional-footer (:green-certs-by-country data) {:margin-top 10})
    {:columns   [{:width 100
                  :stack [(image {:data (:green-certificate-image-1 data)
                                  :width 50})]
                  :alignment :center
                  :margin [0 20 0 0]}
                 {:width 100
                  :stack [(image {:data (:green-certificate-image-2 data)
                                   :width 100})]
                  :alignment :center
                  :margin [0 20 0 0]}]
     :margin [0 0 0 0]})])

(defn share-of-fossil-free-energy-table
  [data]
  [(card/custom-margins-card
    "Share of Renewable Energy"
    [0 0 0 20]
    (horizontal-table-pdf/table (:share-of-fossil-free-energy data))
    (custom-optional-footer (:share-of-fossil-free-energy data)))])

(defn emissions-table
  [data]
  [(card/custom-margins-card
    "Greenhouse Gas Emissions"
    [0 0 0 20]
    (horizontal-table-pdf/table (:emissions data))
    {:columns   [{:width 100
                  :stack [(image {:data (:crrem-logo-image data)
                                  :width 75})]
                  :alignment :left
                  :margin [0 0 0 0]}]
     :margin [0 0 0 0]}
    #_(custom-optional-footer (:emissions data)))])

(defn esg-nps-table
  [data]
  [(card/custom-margins-card
    "Overall Satisfaction & NPS"
    [0 0 0 20]
    (horizontal-table-pdf/table (:esg-nps data))
    (custom-optional-footer (:esg-nps data)))])

(defn nav-breakdown-ifrs-table
  [data]
  [(card/custom-margins-card
    "NAV Breakdown (IFRS), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:nav-breakdown-ifrs data))
    (custom-optional-footer (:nav-breakdown-ifrs data)))])

(defn nav-breakdown-inrev-table
  [data]
  [(card/custom-margins-card
    "NAV Breakdown (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:nav-breakdown-inrev data))
    (custom-optional-footer (:nav-breakdown-inrev data)))])

(defn income-statement-table
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Comprehensive Income (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:income-statement data))
    (custom-optional-footer (:income-statement data)))])

(defn financial-positions-statement-table-1
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Financial Positions (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:financial-positions-statement-1 data))
    (custom-optional-footer (:financial-positions-statement-1 data)))])

(defn financial-positions-statement-table-2
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Financial Positions (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:financial-positions-statement-2 data))
    (custom-optional-footer (:financial-positions-statement-2 data)))])

(defn cash-flows-statement-table-1
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Cash Flows (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:cash-flows-statement-1 data))
    (custom-optional-footer (:cash-flows-statement-1 data)))])

(defn cash-flows-statement-table-2
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Cash Flows (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:cash-flows-statement-2 data))
    (custom-optional-footer (:cash-flows-statement-2 data)))])

(defn glossary-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 20]
    (block-table-pdf/table (:glossary data) {:font-size 7.5
                                             :data-cell-alignment "left"})
    (custom-optional-footer (:glossary data)))])

;; ---------- Charts ----------

(defn nav-per-unit-svg
  [data]
  (let [figures (-> data :nav-per-unit :figures)
        y-axis (:yAxis figures)
        custom-y-axis (assoc (first y-axis) 
                             :max 1.2
                             :min 0
                             :tickInterval 0.1)
        cfg     (assoc {:chart  {:width   1000
                                 :height  550
                                 :spacing [0 0 -10 0]
                                 :margin  [0 0 130 80]
                                 :style {:fontSize "21px"
                                         :fontWeight "normal"}}
                        :legend {:verticalAlign "bottom"
                                 :align         "center"
                                 :padding       10}}
                       :yAxis
                       custom-y-axis)]
    [(card/custom-margins-card-with-background
      "NAV per Unit"
      [0 0 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:nav-per-unit data)))]))

(defn loan-to-gav-svg
  [data]
  (let [figures (-> data :loan-to-gav :figures)
        y-axis (:yAxis figures)
        custom-y-axis (assoc (first y-axis)
                             :max 0.5
                             :min 0
                             :tickInterval 0.1)
        cfg     (assoc {:chart  {:width   1000
                                 :height  500
                                 :spacing [0 0 80 0]
                                 :margin  [0 0 80 80]
                                 :style {:fontSize "21px"
                                         :fontWeight "normal"}}
                        :legend {:verticalAlign "bottom"
                                 :align         "center"
                                 :padding       10}}
                       :yAxis
                       custom-y-axis)]
    [(card/custom-margins-card-with-background
      "Loan-to-GAV"
      [0 20 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:loan-to-gav data)))]))

#_(defn debt-maturity-svg
  [data]
  (let [figures (-> data :debt-maturity :figures)
        cfg     {:chart  {:width   1000
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 80 95]
                          :style {:fontSize "21px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card-with-background
      "Debt Maturity"
      [0 0 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:debt-maturity data)))]))

(defn nav-bridge-svg
  [data]
  (let [figures (-> data :nav-bridge :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 100 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}
                 :yAxis  {:min 500
                          :startOnTick false}}]
    [(card/custom-margins-card-with-background
      "NAV Bridge"
      [0 20 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:nav-bridge data)))]))

(defn fair-value-by-country-donut-svg
  [data]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 60)
        figures   (get-in data [:fair-value-by-country :figures])
        cfg       {:chart       {:width   350
                                 :height  350
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 40]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "21px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :inside true
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      "Fair Value by Country"
      [0 0 10 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})]))

(defn fair-value-by-location-donut-svg
  [data]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 60)
        figures   (get-in data [:fair-value-by-location :figures])
        cfg       {:chart       {:width   350
                                 :height  350
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 40]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "21px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     }}}}]
    [(card/custom-margins-card-with-background
      "Fair Value by Location"
      [0 0 10 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})]))

(defn fair-value-by-type-donut-svg
  [data]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 60)
        figures   (get-in data [:fair-value-by-type :figures])
        cfg       {:chart       {:width   350
                                 :height  350
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 40]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "21px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      "Fair Value by Type"
      [0 0 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})]))

(defn portfolio-noi-and-niy-svg
  [data]
  (let [figures (-> data :portfolio-noi-and-niy :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 -5 0]
                          :margin  [0 80 120 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card-with-background
      "Portfolio NOI and NIY"
      [0 20 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:portfolio-noi-and-niy data)))]))

(defn like-for-like-rental-growth-svg
  [data]
  (when-not (empty-chart-data? (:like-for-like-rental-growth data))
    (let [figures (-> data :like-for-like-rental-growth :figures)
          cfg     {:chart  {:width   900
                            :height  470
                            :spacing [0 0 0 0]
                            :margin  [0 0 80 80]
                            :style {:fontSize "20px"
                                    :fontWeight "normal"}}
                     :legend {:verticalAlign "bottom"
                              :align         "center"
                              :padding       10}}]
      [(card/custom-margins-card-with-background
        "Rental Growth Y-o-Y"
        [0 0 0 20]
        {:svg   (chart-view/chart-svg
                 "highcharts"
                 (potpuri/deep-merge figures cfg))
         :width 530}
        (custom-optional-footer
         (:like-for-like-rental-growth data)))])))

(defn valuation-change-svg
  [data]
  (let [figures (-> data :valuation-change :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 80 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}
                 :yAxis  {:min 800
                          :startOnTick false}}]
    [(card/custom-margins-card-with-background
      "Valuation Change Q-o-Q"
      [0 20 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530}
      (custom-optional-footer
       (:valuation-change data)))]))

#_(defn annual-carbon-intensity
  [data]
  (let [figures (-> data :annual-carbon-intensity :figures)
        cfg     {:chart  {:width   1280
                          :height  430
                          :spacing [0 0 0 30]
                          :margin  [0 0 100 100]
                          :style {:fontSize "30px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card
      "Annual Carbon Intensity"
      [0 0 0 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530
       :height 170}
      (custom-optional-footer
       (:annual-carbon-intensity data)))]))

(defn cmrf-towards-net-zero-svg
  [data]
  (let [figures (-> data :cmrf-towards-net-zero :figures)
        cfg     {:chart  {:width   1380
                          :height  580
                          :spacing [0 0 0 30]
                          :margin  [0 0 130 100]
                          :style {:fontSize "30px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card
      "CMRF Operational Net Zero by 2035 Pathway (SBTi)"
      [0 -30 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530
       :height 280
       :margin [0 -30 0 0]}
      (custom-optional-footer
       (:cmrf-towards-net-zero data)))]))


;; ---------- Pages ----------

(defn fund-summary-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Summary (1/2)"
     :toc-title "Fund Summary"
     :toc-item   true})
   [(fund-summary-table data)
    (strategy-text data)
    (contact-information-1 data)]))

(defn fund-summary-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Summary (2/2)"})
   [(contact-information-2 data)
    (valuation-details-table data)]))

(defn quarter-update-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Commentary"
     :toc-title "Fund Commentary"
     :toc-item   true})
   [(portfolio-update-text data)
    (performance-and-outlook-text data)
    (investment-activity-and-pipeline-text data)
    {:columns   [{:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:quarter-update-image-1 data)
                                  :width (- (/ page/page-width-portrait 2) 25)})]
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack [(image {:data  (:quarter-update-image-2 data)
                                  :width (- (/ page/page-width-portrait 2) 25)})]
                  :margin [-15 0 0 0]}]
     :absolutePosition {:x 20
                        :y 620}}]))

(defn key-metrics-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Key Metrics"
     :toc-item   true})
   [(fund-capital-metrics-table data)
    (fund-kpis-metrics-table data)
    (performance-metrics-table data)
    (portfolio-metrics-table data)]))

(defn market-overview-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Market Overview"
     :toc-item   true})
   [(market-overview-table data)
    (image {:data   (:market-overview-image data)
            :width  (- page/page-width-portrait 40)})]))

(defn fund-returns-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Returns (1/2)"
     :toc-title "Fund Returns"
     :toc-item   true})
   [(fund-returns-table data)
    (benchmark-index-table data)
    (nav-per-unit-svg data)]))

(defn fund-returns-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Returns (2/2)"})
   [(nav-bridge-svg data)]))

(defn debt-financing-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Debt Financing (1/2)"
     :toc-title "Debt Financing"
     :toc-item   true})
   [(debt-kpis-table data)
    (debt-facilities-table data)]))

(defn debt-financing-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Debt Financing (2/2)"})
   [(loan-to-gav-svg data)
    #_(debt-maturity-svg data)]))

(defn portfolio-summary-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (1/3)"
     :toc-title "Portfolio Overview"
     :toc-item   true})
   [(portfolio-summary-table data)
    {:columns
     [{:width  (- (/ page/page-width-portrait 3) 20) 
       :stack  (fair-value-by-country-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (fair-value-by-location-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 30)
       :stack  (fair-value-by-type-donut-svg data)}]
     :columnGap 15}]))

(defn portfolio-summary-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (2/3)"})
   [(portfolio-noi-and-niy-svg data)
    (like-for-like-rental-growth-svg data)]))

(defn portfolio-summary-page-3
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (3/3)"})
   [(valuation-change-svg data)]))

(defn investment-activity-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Investment Activity"
     :toc-item   true})
   [(acquisitions-table data)
    (dispositions-table data)
    {:columns   [{:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:investment-activity-image-1 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 40)
                  :stack [(image {:data  (:investment-activity-image-2 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [0 0 0 0]}]
     :absolutePosition {:x 20
                        :y 620}}]))

(defn sustainability-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Sustainability (1/3)"
     :toc-title "Sustainability"
     :toc-item   true})
   [(esg-summary-text data)
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (gresb-text data)
                  :margin [0 0 0 20]}
                 {:width (- (/ page/page-width-portrait 2) 100)
                  :stack (gresb-by-year-table data)
                  :margin [20 0 0 20]}
                 {:width (- (/ page/page-width-portrait 3) 20)
                  :stack [(image {:data  (:gresb-logo-image data)
                                   :width 55})]
                  :margin [20 10 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (epc-text data)
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (portfolio-epc-table data)
                  :margin [20 0 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (eu-taxonomy-text data)
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack []
                  :margin [0 0 0 0]}]}]))

(defn sustainability-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Sustainability (2/3)"})
   [{:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-certificates-text data)
                  :margin [0 20 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-certs-by-country-table data)
                  :margin [20 20 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-electricity-text data)
                  :margin [0 0 0 40]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (share-of-fossil-free-energy-table data)
                  :margin [20 0 0 40]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (esg-investments-text data)
                  :margin [0 0 0 40]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack [(image {:data  (:esg-investments-image data)
                                   :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [20 0 0 60]}]}
    ]))

(defn sustainability-page-3
  [data]
  (let [crrem-logo-data (:crrem-logo-image data)]
    (page/page
     (page/page-title-vertical-layout
      {:fund-name  (:fund-name data)
       :page-title "Sustainability (3/3)"})
     [{:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                    :stack (crrem-pathway-text data)
                    :margin [0 20 0 (if (cu/blank-value? (:image crrem-logo-data)) 80 0)]}
                   {:width (- (/ page/page-width-portrait 2) 20)
                    :stack (emissions-table data)
                    :margin [20 20 0 (if (cu/blank-value? (:image crrem-logo-data)) 80 0)]}]}
      (cmrf-towards-net-zero-svg data)
      {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                    :stack (tenant-satisfaction-text data)
                    :margin [0 0 0 0]}
                   {:width (- (/ page/page-width-portrait 2) 20)
                    :stack (esg-nps-table data)
                    :margin [20 0 0 0]}]}])))

(defn nav-breakdown-ifrs-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (1/7)"
     :toc-title "Financial Statements"
     :toc-item   true})
   (nav-breakdown-ifrs-table data)))

(defn nav-breakdown-inrev-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (2/7)"})
   (nav-breakdown-inrev-table data)))

(defn income-statement-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (3/7)"})
   [(income-statement-table data)
    (fees-disclosure-text data)]))

(defn financial-positions-statement-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (4/7)"})
   (financial-positions-statement-table-1 data)))

(defn financial-positions-statement-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (5/7)"})
   (financial-positions-statement-table-2 data)))

(defn cash-flows-statement-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (6/7)"})
   (cash-flows-statement-table-1 data)))

(defn cash-flows-statement-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (7/7)"})
   (cash-flows-statement-table-2 data)))

(defn portfolio-denmark-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Portfolio (Denmark)"
   (-> data
       :portfolio-denmark)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :toc-item true
    :page-title "Property Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-denmark data))))

(defn portfolio-finland-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Portfolio (Finland)"
   (-> data
       :portfolio-finland)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :page-title "Property Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-finland data))))

(defn portfolio-sweden-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Portfolio (Sweden)"
   (-> data
       :portfolio-sweden)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :page-title "Property Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-sweden data))))

(defn disclaimer-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Disclaimer"})
   [(disclaimer-text data)]))

(defn glossary-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Glossary"
     :toc-item   true})
   (glossary-table data)))

(defn diagonal-band 
  [{:keys [width band-height angle-deg y svg-height]}]
  (let [h        (or svg-height (* band-height 2))
        cx       (/ width 2)
        cy       (or y (/ h 2))
        rect-w   (* width 3)
        rect-h   band-height
        vb       (str "0 0 " width " " h)]
    (rs/render-to-static-markup
     [:svg {:width width :height h :viewBox vb}
      [:g {:transform (str "rotate(" angle-deg " " cx " " cy ")")}
       [:rect {:x (- cx (/ rect-w 2))
               :y (- cy (/ rect-h 2))
               :width rect-w
               :height rect-h
               :fill "#ffffff"
               :stroke "none"}]]])))

(defn opaque-overlay
  [{:keys [width height color opacity]
    :or   {color "#000000"
           opacity 0.65}}]
  (let [vb (str "0 0 " width " " height)]
    (rs/render-to-static-markup
     [:svg {:width width :height height :viewBox vb}
      [:rect {:x 0
              :y 0
              :width  width
              :height height
              :fill   color
              :fill-opacity opacity
              :stroke "none"}]])))

(defn toc-box-svg
  [{:keys [width height header-h fill header-fill stroke stroke-width]
    :or   {fill "#F0EEEA" header-fill "#FFFFFF" stroke "#000000" stroke-width 1}}]
  (let [vb (str "0 0 " width " " height)]
    (rs/render-to-static-markup
     [:svg {:width width :height height :viewBox vb}
      ;; main filled rect with full border
      [:rect {:x 0 :y 0 :width width :height height
              :fill fill :stroke stroke :stroke-width stroke-width}]
      ;; header fill
      [:rect {:x 0 :y 0 :width width :height header-h
              :fill header-fill :stroke "none"}]
      ;; header borders
      [:line {:x1 0 :y1 0 :x2 width :y2 0
              :stroke stroke :stroke-width stroke-width}]
      [:line {:x1 0 :y1 0 :x2 0 :y2 header-h
              :stroke stroke :stroke-width stroke-width}]
      [:line {:x1 width :y1 0 :x2 width :y2 header-h
              :stroke stroke :stroke-width stroke-width}]])))

(defn toc-page
  [{:keys [report-data]}]
  (let [toc-text-margin-x 20
        toc-text-margin-y 120
        line-height       1.2
        toc-text-width    250
        toc-title         (str (clojure.string/upper-case
                                (or (:reporting-period report-data) ""))
                               " Fund Report")
        cover-image (->> report-data :pdf-cover-image :image)
        toc-image (->> report-data :pdf-toc-image :image)
        ;; box geometry
        box-x             toc-text-margin-x
        box-y             toc-text-margin-y
        box-w             toc-text-width
        box-h             265
        header-h          32
        inner-pad         8
        ;; background placement for TOC page
        bg-x              0
        bg-y              90
        page-w            595
        page-h            842
        bg-h              (- page-h bg-y 45)]
    [(page/page
      "TOC"
      {:stack [(when-not (cu/blank-value? cover-image)
                 {:absolutePosition {:x 0 :y 0}
                  :image (when-not (cu/blank-value? cover-image) cover-image)
                  :width 595 :height 842})
               {:svg (diagonal-band {:width 595 :band-height 500 :angle-deg -15 :y 750})
                :absolutePosition {:x 0 :y 100}}
               {:text     (str (or (:reporting-period report-data) "") " Fund Report")
                :fontSize 45 :font "MarlideDisplay"
                :absolutePosition {:x 252 :y 680} :color "black"}
               {:text     (-> report-data :fund-name (or "") clojure.string/upper-case)
                :fontSize 15 :absolutePosition {:x 320 :y 750} :color "black"}
               {:absolutePosition {:x 480 :y 780}
                :svg (theme/svg-logo) :fit [80 40]}]})
     (page/page
      nil
      {:stack [;; BG image
               (when-not (cu/blank-value? toc-image)
                 {:absolutePosition {:x bg-x :y bg-y}
                  :image toc-image
                  :width page-w :height bg-h})

               ;; Image overlay
               {:absolutePosition {:x bg-x :y bg-y}
                :svg (opaque-overlay {:width page-w :height bg-h
                                      :color "#ffffff" :opacity 0.75})}

               ;; title band
               (page/page-title-vertical-layout
                {:fund-name  (:fund-name report-data)
                 :page-title "Contents"
                 :toc-item   false})

               ;; SVG box
               {:absolutePosition {:x box-x :y box-y}
                :svg (toc-box-svg {:width box-w :height box-h
                                   :header-h header-h
                                   :fill "#F0EEEA"
                                   :header-fill "#FFFFFF"
                                   :stroke "lightgrey"
                                   :stroke-width 1})}

               ;; Header text
               {:absolutePosition {:x (+ box-x 2)
                                   ;; center-ish inside header band
                                   :y (+ box-y (/ (- header-h 14) 2))}
                :table {:widths [125 105]
                        :body   [[{:text toc-title
                                   :bold true
                                   :fontSize 12
                                   :margin [5 0 0 0]
                                   :alignment "left"}
                                  {:text      "Page"
                                   :bold true
                                   :fontSize  12
                                   :alignment "right"}]]}
                :layout "noBorders"}

               ;; TOC list content inside the box
               {:absolutePosition {:x (+ box-x inner-pad)
                                   :y (+ box-y header-h inner-pad)}
                :columns [{:color      (theme/color [:pdf :toc :text])
                           :lineHeight (or line-height 1.65)
                           :toc        {}
                           :fontSize   11
                           :width      (- box-w (* 2 inner-pad))}]}]})]))

(defn appendix-page
  [report-data]
  (let [bg-x              0
        bg-y              0
        page-w            595
        page-h            842
        bg-h              page-h
        toc-image (->> report-data :pdf-toc-image :image)]
    (page/page
     nil
     {:stack [(when-not (cu/blank-value? toc-image)
                {:absolutePosition {:x 0 :y 0}
                 :image (->> report-data :pdf-toc-image :image)
                 :width 595 :height 842})
              {:absolutePosition {:x bg-x :y bg-y}
               :svg (opaque-overlay {:width page-w :height bg-h
                                     :color "#ffffff" :opacity 0.55})}
              {:svg (diagonal-band {:width 595 :band-height 500 :angle-deg -15 :y 750})
               :absolutePosition {:x 0 :y 100}}
              {:text     "Appendix"
               :fontSize 45 :font "MarlideDisplay"
               :absolutePosition {:x 415 :y 700} :color "black"}
              {:absolutePosition {:x 480 :y 780}
               :svg (theme/svg-logo) :fit [80 40]}]})))


(defn snapshot-element [entries image-key]
  (let [single-entry? (= 1 (count entries))]
    {:margin [0 0 0 0]
     :table {:widths [40 220]
             :body
             [[{:image image-key
                :fit [40 40]
                :alignment :center
                :valign :middle
                :margin [0 -1.5 0 -1.5]
                :border [false false false false]
                :fillColor "#F0EEEA"} 
               (if single-entry?
                 (let [{:keys [row-data default-label]} (first entries)
                       value-str (first (:row-data row-data))]
                   {:stack [{:text value-str
                             :fontSize 11
                             :bold true
                             :margin [0 10 0 -5]}
                            {:text (or (:row-key row-data) default-label)
                             :fontSize 10
                             :margin [0 0 0 0]}]
                    :alignment :left
                    :valign :middle
                    :fillColor "#F0EEEA"
                    :border [true true true true]
                    :margin [0 -1.5 0 0]})
                 {:table {:widths ["auto" "*"]
                          :body (mapv (fn [{:keys [row-data default-label]}]
                                        (let [value-str (first (:row-data row-data))]
                                          [{:text value-str
                                            :fontSize 11
                                            :bold true
                                            :margin [0 2 5 -2]
                                            :lineHeight 1.0
                                            :border [false false false false]}
                                           {:text (or (:row-key row-data) default-label)
                                            :fontSize 10
                                            :margin [-8 2 0 -2]
                                            :lineHeight 1.0
                                            :border [false false false false]}]))
                                      entries)}
                  :layout "noBorders"
                  :fillColor "#F0EEEA"
                  :margin [0 3 0 0]
                  :valign :middle
                  :border [false false false false]})]]}
     :layout "noBorders"}))


(defn portfolio-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 0) :default-label "properties"}] "PROPERTIES")
                  (snapshot-element [{:row-data (nth rows 5) :default-label "apartments"}] "APARTMENTS")
                  (snapshot-element [{:row-data (nth rows 1) :default-label "physical occupancy"}] "PHYSICAL OCCUPANCY")
                  (snapshot-element [{:row-data (nth rows 6) :default-label "of GAV in capitals"}] "OF GAV IN CAPITALS")
                  (snapshot-element [{:row-data (nth rows 2) :default-label "average apartment size"}] "AVERAGE APARTMENT SIZE")
                  (snapshot-element [{:row-data (nth rows 7) :default-label "average rent"}] "AVERAGE RENT")
                  (snapshot-element [{:row-data (nth rows 3) :default-label "NIY"}
                                     {:row-data (nth rows 4) :default-label "EY"}] "NIY")
                  (snapshot-element [{:row-data (nth rows 8) :default-label "of portfolio income-generating"}] "OF PORTFOLIO INCOME-GENERATING")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "Portfolio Snapshot"
     [0 20 0 70]
     {:stack rows-of-columns})))


(defn financial-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 0) :default-label "GAV"}
                                     {:row-data (nth rows 1) :default-label "NAV"}] "GAV")
                  (snapshot-element [{:row-data (nth rows 4) :default-label "total return (TTM)"}] "TOTAL RETURN (TTM)")
                  (snapshot-element [{:row-data (nth rows 2) :default-label "LTGAV"}
                                     {:row-data (nth rows 3) :default-label "LTV"}] "LTGAV")
                  (snapshot-element [{:row-data (nth rows 5) :default-label "distribution yield on NAV (TTM)"}] "DISTRIBUTION YIELD ON NAV (TTM)")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "Financial Snapshot"
     [0 0 0 70]
     {:stack rows-of-columns})))

(defn esg-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 3) :default-label "GRESB" :formatter nil}] "GRESB")
                  (snapshot-element [{:row-data (nth rows 0) :default-label "EPC A-C by GAV"}] "EPC A-C BY GAV")
                  (snapshot-element [{:row-data (nth rows 1) :default-label "of assets certified"}] "OF ASSETS CERTIFIED")
                  (snapshot-element [{:row-data (nth rows 2) :default-label "CO2 emissions CO2e/m²"}] "CO2 EMISSIONS CO2e/m²")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "ESG Snapshot"
     [0 0 0 20] 
     {:stack rows-of-columns})))

(defn fund-snapshot-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Snapshot"
     :toc-item   true})
   [(portfolio-snapshot-pdf (:portfolio-snapshot data))
    (financial-snapshot-pdf (:financial-snapshot data))
    (esg-snapshot-pdf (:esg-snapshot data))]))

(defn fund-pages
  [data]
  (concat
   (toc-page {:cover-image :front-page-image
                   :report-data data})
   
   [(fund-summary-page-1 data)]
   [(fund-summary-page-2 data)]

   [(key-metrics-page data)]

   [(fund-snapshot-page data)] ;;TODO

   [(quarter-update-page data)]

   [(market-overview-page data)]

   [(fund-returns-page-1 data)]
   [(fund-returns-page-2 data)]

   [(debt-financing-page-1 data)]
   [(debt-financing-page-2 data)]
   
   [(portfolio-summary-page-1 data)]
   [(portfolio-summary-page-2 data)]
   [(portfolio-summary-page-3 data)]

   [(investment-activity-page data)]

   ;; ESG
   [(sustainability-page-1 data)]
   [(sustainability-page-2 data)]
   [(sustainability-page-3 data)]

   ;; financial statements
   [(nav-breakdown-ifrs-page data)]
   [(nav-breakdown-inrev-page data)]
   [(income-statement-page data)]
   [(financial-positions-statement-page-1 data)]
   [(financial-positions-statement-page-2 data)]
   [(cash-flows-statement-page-1 data)]
   [(cash-flows-statement-page-2 data)]

   [(appendix-page data)]

   ;; country portfolios
   (portfolio-denmark-page data)
   (portfolio-finland-page data)
   (portfolio-sweden-page data)
   
   [(glossary-page data)]
   
   [(disclaimer-page data)]))
